import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Label,
  Input,
  Spinner,
  Nav,
  NavItem,
  NavLink,
  ListGroup,
  ListGroupItem,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import CommonLoading from "../../../Components/Common/CommonLoading";
import {
  ProfileDetailThunk,
  reKyc_digio_requestResponseThunk,
  reKyc_digio_requestThunk,
} from "../../../slices/thunks";

import { showToast } from "../../../Components/ToastNotification";
import Message from "../../../Components/Common/Message";

const IpvDetails = ({ setSteps, steps }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [isProcessing, setIsProcessing] = useState(false);
  const { reKyc_digio_requestData, reKyc_digio_requestLoading } = useSelector(
    (state) => state.Re_Kyc_Digio_Request
  );
  const {
    reKyc_digio_requestResponseData,
    reKyc_digio_requestResponseLoading,
  } = useSelector((state) => state.Re_Kyc_Digio_Request_Response);

  const { reKyc_UpdatePersonalDetailData, reKyc_UpdatePersonalDetailLoading } =
    useSelector((state) => state.Re_Kyc_Update_Personal_Details);

  const Ipv_instructions = [
    "Here we are checking the liveness through the webcam",
    "Ensure that your face is clearly visible.",
    "Mac/iPhone users make sure Block pop-up window is NOT selected. If it is selected, click it to deselect to activate pop-up window.",
    "Initially if you see any error then reload the page.",
  ];

  // Open Digio popup with API response data
  const openDigioPopup = (digioData) => {
    if (!window.Digio) {
      // console.error("Digio SDK not loaded");
      showToast(
        "Digio SDK is not loaded. Please refresh the page and try again.",
        "error"
      );
      setIsProcessing(false);
      return;
    }
    try {
      // Digio configuration with callback
      const options = {
        environment: "production", // or "sandbox" for testing
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            // console.log("Error occurred in process:", response);
            // Handle error
            setIsProcessing(false);
            showToast(response?.message, "error");
            return;
          }
          // console.log("Signing completed successfully:", response);
          dispatch(
            reKyc_digio_requestResponseThunk({
              params: {
                request_id: digioData?.request_id,
                type: "ipv",
              },
              token,
            })
          )
            .then((res) => {
              if (res?.payload?.code === 200) {
                showToast(
                  res?.payload?.message || "Request successful",
                  "success"
                );
              } else {
                showToast(
                  res?.error?.message ||
                    "Something went wrong, please try again",
                  "error"
                );
              }
            })
            .catch((err) => {
              showToast(
                err?.message || "Something went wrong, please try again",
                "error"
              );
            })
            .finally(() => {
              setIsProcessing(false);
            });
        },
        event_listener: function () {
          // Prevent Digio SDK from throwing when trying to call this
          // console.log("Digio event listener triggered");
          setIsProcessing(false);
        },
      };

      // Create new Digio instance
      const digio = new window.Digio(options);

      // Initialize Digio
      digio.init();
      digio.submit(
        digioData?.request_id,
        digioData?.customer_identifier,
        digioData?.access_token
      );
    } catch (error) {
      // console.error("Error opening Digio popup:", error);
      showToast("Error opening Digio: " + error.message, "error");
      setIsProcessing(false);
    }
  };

  const handleIpvDetail = () => {
    dispatch(
      reKyc_digio_requestThunk({ params: { request_type: "ipv" }, token })
    )
      .then((res) => {
        if (res?.payload?.code === 200) {
          openDigioPopup(res?.payload?.data);
        } else {
          showToast(
            res?.error?.message || "Something went wrong, please try again",
            "error"
          );
        }
      })
      .catch((err) => {
        showToast(
          err?.message || "Something went wrong, please try again",
          "error"
        );
      });
  };

  const handleNextIpv = () => {
    const accountStatus = userData?.trade?.account_status;
    const isInactiveUser = accountStatus === 0 || accountStatus === 3;
    const hasValidRekyc =
      userData?.rekyc_progress >= 4 ||
      reKyc_digio_requestResponseData?.is_ipv_done === 1;
    const isEmailPhoneChanged =
      userData?.is_phone_verified === 1 ||
      userData?.is_email_verified === 1 ||
      reKyc_UpdatePersonalDetailData?.is_email_verified === 1 ||
      reKyc_UpdatePersonalDetailData?.is_phone_verified === 1;

    // If rekyc is valid, proceed directly
    if (hasValidRekyc) {
      setSteps(steps + 1);
      return;
    }

    // If email/phone changed, show error first (must verify IPV)
    if (isEmailPhoneChanged) {
      showToast("Please verify ipv details", "error");
      return;
    }

    // If rekyc is not valid and email/phone not changed, check user status
    if (!isInactiveUser) {
      setSteps(steps + 1);
    } else {
      showToast("Please verify ipv details", "error");
    }
  };
  return (
    <React.Fragment>
      <div className="">
      
      {userData?.rekcy_appication_status === "rejected" && (
          <div className=" ">
            <Message
              message={userData?.rekcy_appication_sreason}
              color="danger"
              mb={3}
            />
          </div>
        )} 
       
        <ListGroup flush>
          {Ipv_instructions?.map((point, index) => (
            <ListGroupItem
              key={index}
              className="d-flex align-items-start fs-14 fw-medium border-0 p-1 pt-0"
            >
              <i className="ri-pushpin-line text-primary me-2 fs-5 flex-shrink-0"></i>

              <span>{point}</span>
            </ListGroupItem>
          ))}
        </ListGroup>
        <div className="my-3">
          <button
            type="button"
            className="btn btn-primary"
            disabled={
              reKyc_digio_requestLoading || reKyc_digio_requestResponseLoading ||
              reKyc_digio_requestResponseData?.is_ipv_done === 1 ||
              userData?.rekyc_progress >= 4
            }
            onClick={handleIpvDetail}
            style={{
              minWidth: "120px",
            }}
          >
            {isProcessing || reKyc_digio_requestResponseLoading ? (
              <Spinner size="sm" />
            ) : reKyc_digio_requestResponseData?.is_ipv_done === 1 ||
              userData?.rekyc_progress >= 4 ? (
              "Verified"
            ) : (
              "Connect to IPV"
            )}
          </button>
        </div>
        <Col lg={12}>
          <div className="hstack gap-2 justify-content-end">
            <button
              type="button"
              className="btn btn-soft-secondary"
              onClick={() => {
                setSteps(steps - 1);
              }}
            >
              Prev
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                // setSteps(steps + 1);
                handleNextIpv();
              }}
            >
              Next
            </button>
          </div>
        </Col>
      </div>
    </React.Fragment>
  );
};

export default IpvDetails;
